import { apiClient } from "./ApiClient";


export async function fetchTransactionsAdmin({
  skip,
  limit,
  sort_by,
  sort_order,
  filters,
}) {
  const params = new URLSearchParams({ skip, limit, sort_by, sort_order });

  for (const key in filters) {
    if (filters[key] !== null && filters[key] !== "") {
      if (key === "success") {
        params.append(key, filters[key] === "true");
      } else {
        params.append(key, filters[key]);
      }
    }
  }

  const response = await apiClient.get(`/transaction/batch/admin?${params}`);
  return response.data;
}



export async function requestRefund(transactionId, reason = "Cannot install eSIM") {
  try {
    console.log("Requesting");
    const params = new URLSearchParams({ transaction_id: transactionId, reason: reason });
    console.log("Params", params);
    const response = await apiClient.post(`/transaction/refund/request?${params}`);
    console.log("Response:", response);
    return response.data;
  } catch (error) {
    const err = new Error(error.response?.data?.detail || "Failed to request refund");
    err.status = error.response?.status || error.request?.status || error.status;
    err.response = error.response?.data;
    throw err;
  }
}

export async function fetchInvoicePdf(transactionId) {
  const response = await apiClient.get(`/transaction/invoices/${transactionId}`, {
    responseType: "blob",
    headers: { Accept: "application/pdf" },
  });

  const contentDisposition = response.headers?.["content-disposition"];
  const contentType = response.headers?.["content-type"] || "application/pdf";

  return { blob: response.data, contentDisposition, contentType };
}
